import { useSelector } from 'react-redux';

export function useIsLoading(...keys) {
  const request = useSelector((state: any) => state.request);
  return keys.some((key) => !!request[key]);
}
